import { dashesOrNum } from '@cast/utils';

import { MetricsBox } from 'components/boxes';

type ResourceMetricBoxProps<TKey extends string> = {
  dataKey: TKey;
  value: number | null | undefined;
  unit?: 'GiB' | 'CPU' | '%';
  testId?: string;
  colorMap: Record<TKey, string>;
  titleMap: Record<TKey, string>;
  toggleMetric: (key: TKey) => void;
  isMetricDisabled: (key: TKey) => boolean;
};

export const ResourceMetricBox = <TKey extends string>({
  dataKey,
  value,
  unit,
  testId,
  colorMap,
  titleMap,
  toggleMetric,
  isMetricDisabled,
}: ResourceMetricBoxProps<TKey>) => (
  <MetricsBox
    markerColor={colorMap[dataKey]}
    title={titleMap[dataKey]}
    testId={testId}
    primaryValue={`${dashesOrNum({ value, roundBy: 3, decimals: 1 })}`}
    primaryValueProps={{ variant: 'A1' }}
    gap={4}
    secondaryValue={unit}
    secondaryValueProps={{
      variant: 'L10R',
      color: 'textSecondary',
      textTransform: 'none',
    }}
    titleProps={{ variant: 'L10R' }}
    onClick={() => toggleMetric(dataKey)}
    disabled={isMetricDisabled(dataKey)}
  />
);
